import { apiInstance } from '@shared/api'

const noCacheConfig = {
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  },
}

export const postOrderPositions = async () => {
  const res = await apiInstance.post<PositionsResponse>('/api/v1/order/positions', {}, noCacheConfig)
  return res.data
}

export const postOrderOpen = async () => {
  const res = await apiInstance.post<OpenOrdersResponse>('/api/v1/order/open', {}, noCacheConfig)
  return res.data
}

export const postOrderHistory = async (body: OrderHistoryRequest) => {
  const res = await apiInstance.post<OrderHistoryResponse>('/api/v1/order/history', body, noCacheConfig)
  return res.data
}

export const postOrderAvgTp = async () => {
  const res = await apiInstance.post<AvgTpResponse>('/api/v1/order/avgtp', {})
  return res.data
}
